module.exports = __webpack_public_path__ + "static/media/newlogo-small.e4a5426a.svg";